import React from 'react';

const TextPanel = React.memo(
  ({ text }) => (
    <div
      className="text-panel-component"
      data-testid="text-panel"
    >
      {text}
    </div>
  ),
  ({ text: previousText }, { text }) => previousText === text
);

export default TextPanel;
